// src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaEnvelope, FaSearch } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Section from '../components/common/Section';
import Button from '../components/common/Button';

const NotFoundPage = () => {
  return (
    <Section background="white" padding="lg" className="min-h-[70vh] flex items-center">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="mb-8">
            <div className="flex justify-center mb-6">
              <div className="text-9xl font-bold">
                <span className="text-primary">4</span>
                <span className="text-secondary">0</span>
                <span className="text-primary">4</span>
              </div>
            </div>
            
            <h1 className="text-4xl font-bold text-gray-800 mb-4">
              Oops! Page Not Found
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              The page you are looking for might have been removed, had its name changed, 
              or is temporarily unavailable.
            </p>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-10">
            <h2 className="text-2xl font-bold text-primary-dark mb-6">
              What would you like to do next?
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <motion.div 
                whileHover={{ y: -5 }}
                className="flex flex-col items-center"
              >
                <div className="h-16 w-16 bg-primary-light bg-opacity-20 flex items-center justify-center rounded-full mb-4">
                  <FaHome className="h-8 w-8 text-primary-dark" />
                </div>
                <h3 className="text-lg font-bold mb-2">Return Home</h3>
                <p className="text-gray-600 mb-4">Go back to our homepage and start exploring from there.</p>
                <Button 
                  variant="primary" 
                  to="/"
                >
                  Go to Homepage
                </Button>
              </motion.div>
              
              <motion.div 
                whileHover={{ y: -5 }}
                className="flex flex-col items-center"
              >
                <div className="h-16 w-16 bg-primary-light bg-opacity-20 flex items-center justify-center rounded-full mb-4">
                  <FaSearch className="h-8 w-8 text-primary-dark" />
                </div>
                <h3 className="text-lg font-bold mb-2">Browse Programs</h3>
                <p className="text-gray-600 mb-4">Explore our range of digital skills training programs.</p>
                <Button 
                  variant="outline-primary" 
                  to="/programs"
                >
                  View Programs
                </Button>
              </motion.div>
              
              <motion.div 
                whileHover={{ y: -5 }}
                className="flex flex-col items-center"
              >
                <div className="h-16 w-16 bg-primary-light bg-opacity-20 flex items-center justify-center rounded-full mb-4">
                  <FaEnvelope className="h-8 w-8 text-primary-dark" />
                </div>
                <h3 className="text-lg font-bold mb-2">Contact Us</h3>
                <p className="text-gray-600 mb-4">Can't find what you're looking for? Let's talk!</p>
                <Button 
                  variant="outline-primary" 
                  to="/contact"
                >
                  Contact Support
                </Button>
              </motion.div>
            </div>
          </div>
          
          <div className="text-gray-600">
            <p>If you believe this is an error, please <Link to="/contact" className="text-primary hover:underline">let us know</Link>.</p>
          </div>
        </motion.div>
      </div>
    </Section>
  );
};

export default NotFoundPage;